import Head from "../modules/Head";
import HeaderComponent from "../components/HeaderComponent";
import "../pages/HvalaPasswordPromijenjen.scss";
import useTimeout from "../modules/useTimeout";
import React, { useMemo } from "react";
import { Cookies } from "react-cookie";

function HvalaPasswordPromijenjen() {
  const cookies = useMemo(() => new Cookies(), [])
  useTimeout(() => window.location.replace("/"), 3000);
  cookies.remove('pravnoLice');
  cookies.remove('fizickoLice');
  return (
    <main id="hvala-password-promijenjen">
      <HeaderComponent />
      <Head title="Hvala password promijenjen" />
      <div className="top-left-hvala-password-promijenjen">
        Password je promijenjen
      </div>
      <div className="top-left-lower-hvala-password-promijenjen">
        Uskoro ćete biti vraćeni na početnu stranicu.
      </div>
    </main>
  );
}

export default HvalaPasswordPromijenjen;
